// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider,  } from "react-bootstrap-table2-paginator";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../_metronic/_helpers";
import { Pagination } from "../../../_metronic/_partials/controls";
import moment from "moment";
import { Badge, Button, OverlayTrigger, Tooltip } from "react-bootstrap";

export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 }
];

export function ManualOrdersTable({entities, totalCount, editOrder, deleteOrder, sendToWC, busy = false, queryParams, setQueryParams}) {
    const [loading, setLoading] = useState(false)


    const columns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "business_unit_name",
        text: "U. negocio",
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "customer",
        text: "Cliente",
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "shipping_email",
        text: "Email",
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "wc_id",
        text: "#Órden shop",
        sort: true,
        sortCaret: sortCaret
      },
      {
        dataField: "created_at",
        text: "Fecha",
        sort: true,
        sortCaret: sortCaret,
        formatter: (cellContent) => (
          <span>{ cellContent? moment(cellContent).format("DD/MM/YYYY HH:mm") : '' }</span>
        )
      },
      {
        dataField: "domicilio",
        text: "Domicilio",
        sort: false,
        sortCaret: sortCaret,
        formatter: (cellContent, row) => (
          <>
            <p className="p-0 m-0">{row?.shipping_address_1}</p>
            <p className="p-0 m-0">{row?.shipping_city}</p>
            <p className="p-0 m-0">{row?.shipping_country}</p>
          </>
        )
      },
    //   {
    //     dataField: "waybill_status.order_count",
    //     text: "Cant. Órdenes",
    //     dummyField:true,
    //     classes: "text-center",
    //     headerClasses: "text-center",
    //   },
      {
        dataField: "waybill_status.dispatched",
        text: "Acciones",
        dummyField:true,
        classes: "text-center",
        headerClasses: "text-center",
        headerStyle: { width: '160px' },
        formatter: (cellContent, row) => (
          <>
            <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${row.id}`}>{row.status == 'Borrador' ? 'Editar pedido' : 'Ver pedido'}</Tooltip>}>
              <span>
                <Button className="btn btn-icon btn-light btn-hover-primary btn-sm mr-2" disabled={busy}
                    style={{ cursor: "pointer" }}
                    onClick={()=>editOrder(row, row.status != 'Borrador')} >
                    <span><i className={`fas ${row.status == 'Borrador' ? 'fa-edit' : 'fa-eye'} text-primary`}></i></span>
                </Button>
              </span>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${row.id}`}>Enviar a Woocommerce</Tooltip>}>
              <span>
                <Button className="btn btn-icon btn-light btn-hover-primary btn-sm mr-2"   disabled={busy || row.status != 'Borrador'}
                    style={{ cursor: row.status == 'Borrador' ? "pointer" : "default" }}
                    onClick={()=>sendToWC(row)} >
                    <span><i className="fas fa-cloud-upload-alt text-primary"></i></span>
                </Button>
              </span>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-${row.id}`}>Eliminar pedido</Tooltip>}>
              <span>
                <Button className="btn btn-icon btn-light btn-hover-danger btn-sm mr-2" disabled={busy || row.status != 'Borrador'}
                    style={{ cursor: row.status == 'Borrador' ? "pointer" : "default" }}
                    onClick={()=>deleteOrder(row)} >
                    <span><i className="fas fa-trash text-danger"></i></span>
                </Button>
              </span>
            </OverlayTrigger>
          </>
        ),
      },
      // {
      //   dataField: "description",
      //   text: "Descripción",
      //   sort: true,
      //   sortCaret: sortCaret,
      // },

    ];
    
  
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: sizePerPageList,
        sizePerPage: queryParams.pageSize,
        page: queryParams.pageNumber,
        paginationTotalRenderer: (from, to, size) => (
          <span className="react-bootstrap-table-pagination-total">
            Mostrando { from } a { to } de { size } Resultados
          </span>
        )
    };
  


    return (
      <>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({ paginationProps, paginationTableProps }) => {
            return (
              <>

                <Pagination isLoading={loading} paginationProps={paginationProps} >

                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      bordered={false}
                      condensed={true}
                      // striped={true}
                      remote
                      keyField="id"
                      data= { entities || [] }
                      columns={columns}
                      onTableChange={ getHandlerTableChange( setQueryParams) }
                      {...paginationTableProps}
                    >

                      <PleaseWaitMessage entities={entities} />

                      <NoRecordsFoundMessage entities={entities} />

                    </BootstrapTable>

                </Pagination>
              </>
            );
          }}
        </PaginationProvider>
      </>
    );
}
